import wixData from 'wix-data';

$w.onReady(function () {
    // wixData.query("Templates")
    //   .find()
    //   .then( (results) => {
    // 	  let firstItem = results.items[0];
    // console.log(firstItem.category)
    // });
});

export function categoryBTN_click(event, $w) {
    if ($w('#categoryBTN').label === "כל התבניות") {
        $w("#templatesDS").setFilter(wixData.filter());
    } else {
        let categoryValue = $w('#value').text;
        console.log(categoryValue)
        $w("#templatesDS").setFilter(wixData.filter()
            .contains("category", categoryValue)
        );
    }
}